<template>
    <div v-if="isActive" class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content">
            <div class="box">
                <article class="media">
                    <div class="media-content" style="width: 100%;">
                        <div class="content">
                            <h3 class="title has-text-primary has-text-centered">Create Multiproforma</h3>

                            <div class="card" id="multiproforma-form">
                                <header class="card-header">
                                    <div class="card-header-title">
                                        Create Multiproforma
                                    </div>
                                    <div class="card-header-icon" aria-label="more options">
                                      <span class="icon has-text-danger">
                                        <i class="fas fa-yen" aria-hidden="true"></i>
                                      </span>
                                    </div>
                                </header>
                                <div class="card-content">
                                    <div v-if="alertMessage" class="has-text-success">{{ alertMessage }}</div>
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label>Payment term</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="select is-fullwidth">
                                                    <select v-model="paymentTerm">
                                                        <option value="">Select Payment Term</option>
                                                        <option v-for="payment_term in paymentTerms"
                                                                :value="payment_term">{{ payment_term }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="getMultiProformaErrors.paymentTerm" class="has-text-danger">{{ getMultiProformaErrors.paymentTerm[0] }}</div>
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label>Due date</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded has-icons-left is-fullwidth">
                                                    <datetime
                                                            input-class="input"
                                                            v-model="dueDate"
                                                            :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                                            type="date"
                                                            value-zone="local"
                                                            zone="local"
                                                            placeholder="Select Date"
                                                    ></datetime>
                                                    <span class="icon is-small is-left">
                                                      <i class="fas fa-calendar-alt"></i>
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="getMultiProformaErrors.dueDate" class="has-text-danger">{{ getMultiProformaErrors.dueDate[0] }}</div>
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label>Balance due date</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="select is-fullwidth">
                                                    <select v-model="balanceDate">
                                                        <option value="">Select Date</option>
                                                        <option v-for="balance_date in balanceDates"
                                                                :value="balance_date">{{ balance_date }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="field" v-if="balanceDate == 'Custom'">
                                                <p class="control is-expanded has-icons-left is-fullwidth">
                                                    <datetime
                                                            input-class="input"
                                                            v-model="balanceDateCustom"
                                                            :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                                            type="date"
                                                            value-zone="local"
                                                            zone="local"
                                                            placeholder="Select Balance Due Date"
                                                    ></datetime>
                                                    <span class="icon is-small is-left">
                                                      <i class="fas fa-calendar-alt"></i>
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="getMultiProformaErrors.balanceDate" class="has-text-danger">{{ getMultiProformaErrors.balanceDate[0] }}</div>
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label>Incoterm</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <div class="select is-fullwidth">
                                                    <select v-model="incotermModel">
                                                        <option value="">Select Incoterm</option>
                                                        <option v-for="incoterm in incoterms"
                                                                :value="incoterm">{{ incoterm }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="getMultiProformaErrors.incoterm" class="has-text-danger">{{ getMultiProformaErrors.incoterm[0] }}</div>
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label>Includes</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <label class="checkbox">
                                                    <input type="checkbox" :checked="getIncludes.indexOf('seal') > -1"
                                                           @click="handleIncludes('seal')">
                                                    Seal
                                                </label>
                                                <label class="checkbox">
                                                    <input type="checkbox" :checked="getIncludes.indexOf('sign') > -1" @click="handleIncludes('sign')">
                                                    Sign
                                                </label>
                                                <label class="checkbox">
                                                    <input type="checkbox" :checked="getIncludes.indexOf('term') > -1" @click="handleIncludes('term')">
                                                    Terms And Condition
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label>B/L Number</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded ">
                                                    <input v-model="blNumber" class="input" type="text"
                                                           placeholder="B/L NUMBER">
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="getMultiProformaErrors.blNumber" class="has-text-danger">{{ getMultiProformaErrors.blNumber[0] }}</div>
                                    <div class="field is-horizontal">
                                        <div class="field-label is-normal">
                                            <label>Remarks</label>
                                        </div>
                                        <div class="field-body">
                                            <div class="field">
                                                <p class="control is-expanded ">
                                                   <textarea class="textarea" placeholder="Remarks"
                                                             v-model="remarks"
                                                   ></textarea>

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="getMultiProformaErrors.remarks" class="has-text-danger">{{ getMultiProformaErrors.remarks[0] }}</div>
                                    <div class="field">
                                        <button class="button is-primary enquiry"
                                                :class="{ 'is-loading' : isLoading }" @click="createShippingMultiproforma">Create
                                        </button>
                                        <button class="button" v-if="getMultiProformaId" @click.prevent="downloadMultiproformaExcel(getMultiProformaId)">
                                            <span class="icon is-small">
                                              <i class="fas fa-file-excel"></i>
                                            </span>
                                            <span>Output (EXCEL)</span>
                                        </button>
                                        <button class="button" v-if="getMultiProformaId" @click.prevent="downloadMultiproformaPDF(getMultiProformaId)">
                                            <span class="icon is-small">
                                              <i class="fas fa-file-pdf"></i>
                                            </span>
                                            <span>Output (PDF)</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="has-text-centered mt-15">
                                <a class="button" @click="closeModal">close</a>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {Datetime} from 'vue-datetime'
    import apiProformaInvoices from './../../api/apiProformaInvoices'

    export default {
        components: {
            Datetime
        },
        props: ['lot', 'user'],
        data() {
            return {
                paymentTerms: ['100%', '50%-50%', '30%-70%'],
                balanceDates: ['1 Week', '2 Weeks', '3 Weeks', '1 Month', '2 Months', '3 Months', 'Custom'],
                incoterms: ['FOB', 'CIF', 'C&F'],
                remarks:''
            }
        },
        computed: {
            isActive() {
                return this.$store.getters.getCreateMultiProformaModal
            },
            alertMessage() {
                return this.$store.getters.getStockCarAlertMessage
            },
            errorMessage() {
                return this.$store.getters.getStockCarErrorMessage
            },
            isResponse() {
                return this.$store.getters.isResponse
            },
            getCarObj() {
                return this.$store.getters.getStockCarObj.lot
            },
            getUser() {
                return this.$store.getters.getStockCarObj.user
            },
            getCounterOffer() {
                return this.$store.getters.getStockCarObj.counterOffer
            },
            isLoading() {
                return this.$store.getters.getDownloadingStatus
            },
            getGroupIds(){
                return this.$store.getters.getGroupIds
            },
            getMultiProformaErrors(){
                return this.$store.getters.getMultiProformaErrors
            },
            paymentTerm: {
                get(){
                    return this.$store.getters.getMultiProformaLatest.payment_term
                },
                set(value){
                    this.$store.dispatch('updateMultiProformaLatest', {'payment_term': value})
                }
            },
            dueDate: {
                get() {
                    return this.$store.getters.getMultiProformaLatest.due_date
                },
                set(value){
                    this.$store.dispatch('updateMultiProformaLatest', {'due_date': value})
                }
            },
            balanceDate: {
                get() {
                    let balanceDueDate = this.$store.getters.getMultiProformaLatest.balance_due_date
                    return balanceDueDate.indexOf('Custom') > -1 ? 'Custom' : balanceDueDate
                },
                set(value){
                    this.$store.dispatch('updateMultiProformaLatest', {'balance_due_date': value})
                }
            },
            balanceDateCustom: {
                get() {
                    let balanceDueDate = this.$store.getters.getMultiProformaLatest.balance_due_date
                    return balanceDueDate.indexOf('Custom') > -1 ? balanceDueDate.replace('Custom ', '') : balanceDueDate
                },
                set(value){
                    this.$store.dispatch('updateMultiProformaLatest', {'balance_due_date': "Custom "+value})
                }
            },
            incotermModel: {
                get() {
                    return this.$store.getters.getMultiProformaLatest.incoterm
                },
                set(value){
                    this.$store.dispatch('updateMultiProformaLatest', {'incoterm': value})
                }
            },
            getIncludes() {
                return this.$store.getters.getMultiProformaLatest.includes_seal.split(',')
            },
            blNumber: {
                get() {
                    return this.$store.getters.getMultiProformaLatest.bl_number
                },
                set(value){
                    this.$store.dispatch('updateMultiProformaLatest', {'bl_number': value})
                }
            },
            getMultiProformaId(){
                return this.$store.getters.getMultiProformaId
            }
        },
        methods: {
            closeModal() {

                this.$store.dispatch('setMultiProformaId', '');
                this.$store.dispatch('setCreateMultiProformaModal', false);
            },
            createShippingMultiproforma() {
                //this.alertMessage = null;
                //this.errorMessage = null;
                this.$store.dispatch('createShippingMultiproforma', {
                    paymentTerm: this.paymentTerm,
                    dueDate: this.dueDate,
                    balanceDate: this.balanceDate.indexOf('Custom') > -1 ? this.balanceDate+' '+this.balanceDateCustom : this.balanceDate,
                    incoterm: this.incotermModel,
                    includes: this.getIncludes,
                    blNumber: this.blNumber,
                    remarks: this.remarks,
                    groupIds: this.getGroupIds
                })
                this.remarks = ''
            },
            imgUrlAlt(event) {
                event.target.src = '/static/images/hero-4.jpeg'
            },
            handleIncludes: function (includes) {
                let includesSeal = this.getIncludes
                let findPos = includesSeal.indexOf(includes)
                if(findPos < 0){
                    includesSeal.push(includes)
                }else{
                    includesSeal.splice(findPos, 1)
                }
                this.$store.dispatch('updateMultiProformaLatest', {'includes_seal': includesSeal.join(',')})
            },
            downloadMultiproformaExcel(id) {
                apiProformaInvoices
                    .downloadShippingMultiproformaInvoices(id)
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]), {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'MULTI_INV.xlsx')
                        document.body.appendChild(link)
                        link.click()
                        commit('setDownloadStatus', false)
                        resolve()
                    })
                    .catch(error => {
                        commit('setDownloadStatus', false)
                        console.log(error)
                        //commit('setErrors', JSON.parse(error.response.data))
                        reject()
                    })
            },
            downloadMultiproformaPDF(id) {
                apiProformaInvoices
                    .downloadMultiproformaPDF(id)
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]))
                        const link = document.createElement('a')
                        link.href = url
                        const name = Number(id).toString().padStart(6, 0)
                        link.setAttribute('download', 'MULTI_INV-'+ name + '.pdf')
                        document.body.appendChild(link)
                        link.click()
                    })
                    .catch((error) => console.log(error))
            }
        },
        created() {
            this.$store.dispatch('fetchMultiProformaLatest')
            axios.get('https://restcountries.com/v3.1/all?fields=name')
                .then((response) => {
                    this.countries = response.data
                })
        }
    }
</script>

<style scoped>
    div#multiproforma-form label {
        min-width: 130px;
        display: block;
        text-align: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/Cars/CreateMulitProformaModal.vue